import { render, staticRenderFns } from "./PageBuilderPreview.vue?vue&type=template&id=7b6e21a4&"
import script from "./PageBuilderPreview.vue?vue&type=script&lang=js&"
export * from "./PageBuilderPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports